'use strict';

var box = require('../../../../../../../../../../_virtual/box2.cjs');

var hasRequiredBox;

function requireBox () {
	if (hasRequiredBox) return box.__exports;
	hasRequiredBox = 1;

	var BOX_SIZES = /*#__PURE__*/ function(BOX_SIZES) {
	    BOX_SIZES["none"] = "none";
	    BOX_SIZES["xsmall"] = "xsmall";
	    BOX_SIZES["small"] = "small";
	    BOX_SIZES["large"] = "large";
	    return BOX_SIZES;
	}({});

	box.__exports.BOX_SIZES = BOX_SIZES;
	
	return box.__exports;
}

exports.__require = requireBox;
//# sourceMappingURL=box.cjs.map
